<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Activation Key
              <router-link
                :to="{ name: 'ActivationPinAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Activation Key</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
              <!-- <button
                  class="btn btn-success"
                  type="button"
                  @click=""
              >
                  Bulk Upload
              </button> -->
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i>
                <span class="d-none d-sm-inline-flex">Export</span>
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt=""/>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Email -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="email"
                    >Email</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="email"
                          name="email"
                          v-model="filter.email"
                          class="form-control"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- mac -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="mac"
                    >MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="mac"
                          name="mac"
                          v-model="filter.mac"
                          class="form-control"
                          placeholder="MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Status -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                    >Status</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.activation_status"
                          :options="pre.unique_provision_status"
                          placeholder="Status"
                          :searchable="true"
                          :multiple="false"
                          id="status"
                          name="status"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- Serial -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="serial"
                    >Serial</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="serial"
                          name="serial"
                          v-model="filter.serial"
                          class="form-control"
                          placeholder="Serial"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Organization -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="org_id"
                    >Organization</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.org_id"
                          :options="Object.keys(pre.organizations)"
                          :custom-label="opt => pre.organizations[opt]"
                          placeholder="Select Organization"
                          :searchable="true"
                          :multiple="false"
                          id="org_id"
                          name="org_id"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Model No -->
                  <!-- <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="device_type"
                    >Model No</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="device_type"
                          name="device_type"
                          v-model="filter.device_type"
                          class="form-control"
                          placeholder="Model No"
                        />
                      </div>
                    </div>
                  </div> -->
                   <!-- <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="org_id"
                      >Model No</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.device_type"
                          :options="Object.keys(pre.models)"
                          :custom-label="opt => pre.models[opt]"
                          placeholder="Select Model"
                          :searchable="true"
                          :multiple="false"
                          id="model_id"
                          name="model_id"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div> -->
                <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="model_id"
                      >Model No</label
                    >
               <div class="col-md-9">
                 <div class="input-group">
                  <el-select
                  class="w-100"
                  v-model="filter.device_type"
                  placeholder="Select Model"
                  filterable
                  clearable
                  :class="{ 'has-error': errors.has('model') }"
                  name="device_type"
                  >
<!--                  <el-option-->
<!--                    v-for="(item, key) in pre.models"-->
<!--                    :label="item"-->
<!--                    :value="item"-->
<!--                    :key="item"-->
<!--                  />-->
                    <el-option
                      v-for="product in pre.allproduct"
                      :key="product.device_type"
                      :label="product.alias + ' ('+product.device_type+')'"
                      :value="product.device_type"
                    />
                </el-select>
                 </div>
               </div>
              </div>
                </div>
              </div>
              <div class="form-row"></div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px">
                        <i class="icon-search"></i> Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-outline"
                        @click="resetFilter()"
                      >
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6 v-if="organizationId == 1">Total Item: {{ list.total }}</h6>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>Data Center</th>
                    <th>MAC</th>
                    <th>Email</th>
                    <th>Product</th>
                    <th>Model No</th>
                    <th>Pin</th>
                    <th>Activated</th>
                    <th>Activation Status</th>
                    <th>Serial</th>
                    <th>License</th>
                    <th>Organization</th>
                    <th class="text-right">Action</th>
                  </tr>
                  </thead>
                  <tbody class="list">
                  <tr v-for="(val, index) in list.data">
                    <td>{{ val.timezonewise_configuration ? val.timezonewise_configuration.dc_name : '' }}</td>
                    <td>{{ val.mac }}</td>
                    <td>{{ val.account ? val.account.activation_email : '' }}</td>
                    <td>{{ val.application_alias ? val.application_alias.alias : '' }}</td>
                    <td>{{ val.device_type }}</td>
                    <td>{{ val.actv_key }}</td>
                    <td>{{ val.account ? val.account.activation_date : '' }}</td>
                    <td>{{ val.activation_status }}</td>
                    <td>{{ val.serial }}</td>
                    <td>{{ val.license_user }}</td>
                    <td>{{ val.organization ? val.organization.org_name : '' }}</td>
                    <td class="text-right">
                      <router-link
                          v-if="actionEdit == true"
                        :to="{
                            name: 'ActivationPinEdit',
                            params: { id: val.id }
                          }"
                        class="btn btn-edit"
                      >
                        <i class="icon-edit"></i>
                      </router-link>
                      <a
                          v-if="actionDelete == true"
                        class="btn btn-trash"
                        href="javascript:void(0)"
                        @click="deleteObject(val.id, index)"
                      ><i class="icon-trash"></i
                      ></a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt=""/>
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import {CommonAPI, PermissionChecker} from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import {Notification} from 'element-ui'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {mapGetters} from 'vuex'
import {fileDownload} from '@/utils/CommonUtils'

export default {
  name: 'ActivationPin',
  metaInfo: {
    title: 'Activation Key | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    organizationId: LocalStorage.get('organizationId'),
    userEmail: LocalStorage.get('userEmail'),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: {
      models :{},
      organizations: {},
      status: ['ACTIVE', 'INACTIVE', 'USED'],
      provision_states_list: [], // Added provision states list
      deprovision_reason: {}, // Added deprovision reason object
      device_name: [],
      allproduct: [],
    },
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    provision_list_api_url: '/provision_state',
  }),
  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url = '/activation_pins'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize() {

      this.is_loading = true

      await this.getOrganizations()
        .then(response => {
          this.pre.organizations = response.data
        })
        .catch(error => {
          console.log(error.response)
        })

      await this.getAllProduct()
        .then((response) => {
          this.pre.allproduct = response.data;
        })
        .catch((error) => {
          this.pre.allproduct = [];
        });

     await this.getProvisionList()
        .then(response => {
          this.pre.provision_states_list = response.data
          const tmp = {}
          const uniqueStates = new Set()

          for (let i = 0; i < this.pre.provision_states_list.length; i++) {
            const states = this.pre.provision_states_list[i]

            // Collect unique from_state values
            uniqueStates.add(states.from_state)

            if (states.from_state === 'De-Activated') {
              if (!tmp.hasOwnProperty(states.to_state)) {
                tmp[states.to_state] = []
              }
              tmp[states.to_state].push(states.to_state_sub)
            }
          }

          this.pre.deprovision_reason = tmp
          this.pre.unique_provision_status = Array.from(uniqueStates)
        })
        .catch(error => {
          console.error('Error fetching provision states:', error)
        })

      if ('mac' in this.$route.query) {
        this.filter.mac = this.$route.query.mac
        this.showFilter = true
      }
      if ('email' in this.$route.query) {
        this.filter.email = this.$route.query.email
        this.showFilter = true
      }
      if ('activation_status' in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status
        this.showFilter = true
      }
      if ('serial' in this.$route.query) {
        this.filter.serial = this.$route.query.serial
        this.showFilter = true
      }
      if ('org_id' in this.$route.query) {
        this.filter.org_id = this.$route.query.org_id
        this.showFilter = true
      }
      if ('device_type' in this.$route.query) {
        this.filter.device_type = this.$route.query.device_type
        this.showFilter = true
      }

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }
      // check if "administrator" exists
      let roles = this.user_detail.roles ?? []
      const isAdmin = roles.some((role) => role.slug === "administrator")
      console.log('isAdmin', isAdmin)
      if (isAdmin) {
        this.actionCreate = true
        this.actionView = true
        this.actionEdit = true
        this.actionDelete = true
      } else {
        this.actionCreate = false
        this.actionView = true
        this.actionEdit = false
        this.actionDelete = false
      }

      //  await CommonAPI.getCustomPermission(
      //     '/get-custom-permission-infos?path=api/activation_pins'
      //   ).then(response => {
      //     if (response.status == 200) {
      //       this.custom_permission_data = response.data
      //     }
      //   })

      //   if (!_.isEmpty(this.custom_permission_data)) {
      //     this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //       this.custom_permission_data.action_permission,
      //       this.custom_permission_data['create_id_condition'],
      //       this.user_detail,
      //       this.custom_permission_data.enableAdministratorPermissionByDefault
      //     )
      //   }

      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })

      this.is_loading = false
    },

    async getFilterData() {
      this.is_loading = true
      this.$router
        .push({
          path: this.$route.fullPath,
          query: {
            mac: this.filter.mac,
            email: this.filter.email,
            activation_status: this.filter.activation_status,
            serial: this.filter.serial,
            device_type: this.filter.device_type,
            org_id: this.filter.org_id,
          }
        })
      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    reload: function () {
      if ('mac' in this.$route.query) {
        this.filter.mac = this.$route.query.mac
        this.showFilter = true
      }
      if ('email' in this.$route.query) {
        this.filter.email = this.$route.query.email
        this.showFilter = true
      }
      if ('activation_status' in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status
        this.showFilter = true
      }
      if ('serial' in this.$route.query) {
        this.filter.serial = this.$route.query.serial
        this.showFilter = true
      }
      if ('org_id' in this.$route.query) {
        this.filter.org_id = this.$route.query.org_id
        this.showFilter = true
      }
      if ('device_type' in this.$route.query) {
        this.filter.device_type = this.$route.query.device_type
        this.showFilter = true
      }

      this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
    },
    getList: function () {
      const _this = this
      return new Promise((resolve, reject) => {
        let params = {page: this.list.current_page}
        params = {
          ...this.filter,
          organizationId: this.organizationId,
          ...this.$route.query,
          ...params
        }
        axios
          .get(this.api_url, {
            params: params
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          })
      })
    },
    getProvisionList: function () {
      return new Promise((resolve, reject) => {
        axios
          .get(this.provision_list_api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    async resetFilter() {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      this.$router
        .push({
          path: this.$route.path,
          query: {}
        })
      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true

          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
      this.is_loading = false
    },
    deleteObject: function (id, accountId, index) {
      const _this = this
      const delete_api_url = '/activation_pins/' + id

      _this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.isConfirmed) {
            _this.is_loading = true
            axios
              .delete(delete_api_url)
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire('Failed!', 'failed to delete.', 'error')
              })
              .finally(() => {
                _this.is_loading = false
              })
          }
        })
    },
    exportFile: function () {
      this.is_loading = true
       let params = {
          ...this.filter,
          organizationId: this.organizationId,
          userAccountId: LocalStorage.get('accountId'),
          ...this.$route.query
        }
      axios
        .get('/activation_pins-export', {
          params: params,
          responseType: 'blob'
        })
        .then(response => {
          fileDownload(response.data, 'activation_pins.xlsx')
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
          Notification.success({
            title: 'Export Completed',
            message: 'Export operation completed successfully',
            type: 'success'
          })
        })
    },

    getOrganizations: function () {
      return new Promise((resolve, reject) => {
        axios
          .get('get-activation-pin-organizations', {
            params: {accountId: LocalStorage.get('accountId')}
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    getModels: function () {
      return new Promise((resolve, reject) => {
        axios
          .get('get-activation-pin-models', {
            params: { accountId: LocalStorage.get('accountId')}
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    getAllProduct: function () {
      return new Promise((resolve, reject) => {
        let params = {
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
        };
        axios
          .get("/provision-product", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  }
}
</script>
